<template>
  <!-- <van-tab :title="clazzType.title"> -->
    <van-list
      v-model="loading"
      finished-text="没有更多了"
      :finished="finished"
      :immediate-check="true"
      @load="onLoad"
    >
      <clazz-panel v-for="(item, index) in list" :key="index" :clazz="item" />
    </van-list>
  <!-- </van-tab> -->
</template>

<script>
import { Icon, Tab, List } from 'vant'
import ClazzPanel from './ClazzPanel'
import { clazzList } from '@/api/clazz'

export default {
  name: 'ClazzTab',
  components: {
    [Icon.name]: Icon,
    [Tab.name]: Tab,
    [List.name]: List,
    ClazzPanel
  },
  props: {
    clazzType: {
      type: Object
    }
  },
  data () {
    return {
      list: [],
      loading: false,
      finished: false,
      listQuery: {
        is_improve_info: 1,
        page: 0,
        size: 8
      }
    }
  },
  created () {
    this.listQuery.clazz_type = this.clazzType.clazz_type
  },
  methods: {
    async getList () {
      this.loading = true
      let response = await clazzList(this.listQuery)
      this.loading = false
      this.pullLoading = false
      this.list = this.list.concat(response.data.results)
      this.checkFinished(response.data.count)
    },
    onLoad () {
      this.listQuery.page += 1
      this.getList()
    },
    checkFinished (total) {
      this.finished = this.list.length >= total
    }
  }
}
</script>

<style scoped lang="scss">
</style>
